/** Révision monotone de la pension (stockée dans `users.daycare.revision`). */
export function normalizeDaycareRevision(value) {
  const n = Math.floor(Number(value) || 0)
  return Number.isFinite(n) && n >= 0 ? n : 0
}

/** Le client peut-il appliquer cet état ? (strictement plus récent que le serveur). */
export function canApplyClientDaycareRevision(serverRevision, clientRevision) {
  const s = normalizeDaycareRevision(serverRevision)
  const c = normalizeDaycareRevision(clientRevision)
  return c > s
}

/**
 * Variante avec révision de base : le client envoie aussi la révision serveur sur laquelle
 * son état est construit. Si le serveur a avancé entre-temps (éclosion, offline, admin…),
 * l'état client est périmé → refus, même si son compteur local est plus grand. Sans ça, un
 * PUT parti avec un œuf déjà éclos côté serveur le « ressuscitait » (éclosion en double,
 * étoile en plus). `baseRevision` absent (ancien client) → règle historique seule.
 */
export function canApplyClientDaycareSave(serverRevision, clientRevision, baseRevision) {
  if (!canApplyClientDaycareRevision(serverRevision, clientRevision)) return false
  if (baseRevision === undefined || baseRevision === null) return true
  return normalizeDaycareRevision(baseRevision) === normalizeDaycareRevision(serverRevision)
}

/** Révision après écriture serveur autoritaire (offline, admin, etc.). */
export function nextDaycareRevision(current) {
  return normalizeDaycareRevision(current) + 1
}

/**
 * Saut de révision appliqué au reset pension de l'ascension. Grand exprès : le reset autoritaire
 * doit DOMINER tout état client périmé non synchronisé (sinon `canApplyClientDaycareRevision`
 * laisse une vieille pension écraser le reset → Pokémon « ressuscités » après ascension).
 * Un +1 ne suffit pas : la panne de sauvegarde implique justement des révisions client non sync.
 */
export const DAYCARE_ASCENSION_REVISION_BUMP = 1_000_000

/** Révision de pension à poser au reset d'ascension : domine la révision serveur courante. */
export function ascensionResetDaycareRevision(currentRevision) {
  return normalizeDaycareRevision(currentRevision) + DAYCARE_ASCENSION_REVISION_BUMP
}
